export default function FormInput({
  label,
  type = "text",
  value,
  onChange,
  placeholder = "",
  required = false,
  error = "",
  helperText = "",
  disabled = false,
  options = [],
}) {
  const baseClasses =
    "w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none transition";

  return (
    <div className="mb-4">
      {label && (
        <label className="block font-medium mb-1">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {type === "textarea" && (
        <textarea
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`${baseClasses} h-24 resize-none ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        />
      )}

      {type === "select" && (
        <select
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`${baseClasses} ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        >
          <option value="">Select an option</option>
          {options.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      )}

      {type !== "textarea" && type !== "select" && (
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`${baseClasses} ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        />
      )}

      {helperText && !error && (
        <p className="text-sm text-gray-500 mt-1">{helperText}</p>
      )}

      {error && (
        <p className="text-sm text-red-600 mt-1 font-medium">{error}</p>
      )}
    </div>
  );
}
